export default "__VITE_ASSET__nlqzn44h__"